module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.controlerBtnSubmit) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.downloadAnexo()
      }
    }
  }, [_vm._v("Franquia Negociações")]) : _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "button",
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Carregando Negociações...")]), _c('br'), _vm._v(" "), (_vm.controlerBtnSubmit) ? _c('span', {
    staticStyle: {
      "font-size": "10px",
      "color": "red"
    }
  }, [_c('svg', {
    staticClass: "bi bi-exclamation-circle",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "12",
      "height": "12",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z"
    }
  })]), _vm._v(" "), _c('b', [_vm._v("O tempo de download pode variar conforme o número de estados do usuário.")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8bd0a094!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/planilha/planilhas-adm/ExportHistoricoNegociacoes.vue
// module id = 1015
// module chunks = 1